import styled from 'styled-components';
import { ReactComponent as LockIcon } from 'Images/ws-lock.svg';

// eslint-disable-next-line import/prefer-default-export
export const Lock = styled(LockIcon)`
  cursor: pointer;
  width: 14px;
  height: 14px;
  margin-left: 8px;
  path {
    fill: ${({ theme }) => theme.icons.actionBar.color};
  }
`;
Lock.displayName = 'Lock';
